import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

/**
 *
 * @param project called when the observed value is null or undefined
 * @returns Observable<Tout>
 */
export function valueOrSwitchMap<TIn, TOut>(project: () => Observable<TOut>) {
  return (observable: Observable<TIn | null | undefined>) =>
    observable.pipe(switchMap((r) => (r != null ? of(r) : project())));
}
